module.exports = __webpack_public_path__ + "img/level_4c.5488c531.png";